module.exports = __webpack_public_path__ + "img/Hr_UI_Button_play.95051838.png";